export const updateModellTypeGelaender = ev => {
    return {
        type: 'UPDATEMODELLTYPEGELAENDER',
        ev: ev
    }
}

export const updateModellGelaender = ev => {
    return {
        type: 'UPDATEMODELLGELAENDER',
        ev: ev
    }
}

export const updateMusterGelaender = ev => {
    return {
        type: 'UPDATEMUSTERGELAENDER',
        ev: ev
    }
}

export const updateGrundrissGelaender = ev => {
    return {
        type: 'UPDATEGRUNDRISSGELAENDER',
        ev: ev
    }
}

export const updateWrapperIndexGelaender = ev => {
    return {
        type: 'UPDATEWRAPPERINDEXGELAENDER',
        ev: ev
    }
}

export const updateStepsGelaender = ev => {
    return {
        type: 'UPDATESTEPSGELAENDER',
        ev: ev
    }
}

export const updateAllVisitedStepsGelaender = () => {
    return {
        type: 'UPDATEALLVISITEDSTEPSGELAENDER'
    }
}

export const updadteHeightGelaender = ev => {
    return {
        type: 'UPDATEHEIGHTGELAENDER',
        ev: ev
    }
}

export const updateWidthGelaender = ev => {
    return {
        type: 'UPDATEWIDTHGELAENDER',
        ev: ev
    }
}

export const addSingleElementGelaender = () => {
    return {
        type: 'ADDSINGLEELEMENTGELAENDER'
    }
}

export const updateSingleElementGelaender = ev => {
    return {
        type: 'UPDATESINGLEELEMENTGELAENDER',
        ev: ev
    }
}

export const deleteSingleElementGelaender = ev => {
    return {
        type: 'DELETESINGLEELEMENTGELAENDER',
        ev: ev
    }
}

export const updateWidthTotalGelaender = ev => {
    return {
        type: 'UPDATEWIDTHTOTALGELAENDER',
        ev: ev
    }
}

export const selectKindDimensionGelaender = ev => {
     return {
         type: 'SELECTKINDDIMENSIONGELAENDER',
         ev: ev
     }
}

export const updateHandtrailFormGelaender = ev => {
    return {
        type: 'UPDATEHANDTRAILFORMGELAENDER',
        ev: ev
    }
}

export const updateHandtrailEndkappeGelaender = ev => {
    return {
        type: 'UPDATEHANDRAILENDKAPPEGELAENDER',
        ev: ev
    }
}

export const updateHandtrailPieceKindGelaender = ev => {
    return {
        type: 'UPDATEHANDTRAILPIECEKINDGELAENDER',
        ev: ev
    }
}

export const updatePfostenFormGelaender = ev => {
    return {
        type: 'UPDATEPFOSTENFORMGELAENDER',
        ev: ev
    }
}

export const updateBefestigungsartGelaender = ev => {
    return {
        type: 'UPDATEBEFESTIGUNGSARTGELAENDER',
        ev: ev
    }
}

export const selectKindOfColorGelaender = ev => {
    return {
        type: 'SELECTKINDOFCOLORGELAENDER',
        ev: ev
    }
}

export const selectColorGelaender = ev => {
    return {
        type: 'SELECTCOLOROFGELAENDER',
        ev: ev
    }
}

export const selectWishColorGelaender = ev => {
    return {
        type: 'SELECTWISHCOLORGELAENDER',
        ev: ev
    }
}

export const updateFestening = ev => {
    return {
        type: 'UPDATEFESTENING',
        ev: ev
    }
}

export const updateProductToMerklisteGelaender = ev => {
    return {
        type: 'UPDATEPRODUCTTOMERKLISTEGELAENDER',
        ev: ev
    }
}

export const updateGlasartGelaender = ev => {
    return {
        type: 'UPDATEGLASARTGELAENDER',
        ev: ev
    }
}

export const selectUploadDataGelaender = ev => {
    return {
        type: 'SELECTUPLOADDATAGELAENDER',
        ev: ev
    }
}

export const updateDescriptionGelaender = ev => {
    return {
        type: 'UPDATEDESCRIPTIONGELAENDER',
        ev: ev
    }
}

export const updateModallTitelGelaender = ev => {
    return {
        type: 'UPDATEMODALLTITELGELAENDER',
        ev: ev
    }
}

export const selectImageCategoryGelaender = ev => {
    return {
        type: 'SELECTIMAGECATEGORYGELAENDER',
        ev: ev
    }
}